const PoliciesSummaryGridComponent = {
    templateUrl: '/content/policiesSummaryGrid/policiesSummaryGrid.tpl.html',
    controller: 'policiesSummaryGridController',
    bindings: {
        isColumnFilterVisible: '<?',
        isGridFilterVisible: '<?',
        isViewActiveVisible: '<?',
        isSearchVisible: '<?',
        isGridPagingVisible: '<?',
        selectedSubmissionIds: '<',
        gridColumnsPreference: '<?'
    }
};

angular.module('gw-um-submission')
    .component('uiPoliciesSummaryGrid', PoliciesSummaryGridComponent);
